<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
    <p *ngIf="data.type !== ''">{{data.type}}</p>
    <p *ngIf="data.fileName !== ''">{{data.fileName}}</p>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button (click)="confirmDialog(false)">Cancel</button>
    <button mat-raised-button (click)="confirmDialog(true)">Yes</button>
</mat-dialog-actions>